import React from 'react'
import './Product.css';
import { useStateValue } from "./StateProvider";

function Product({ id, title, image, price }) {
    
    const [{}, dispatch] = useStateValue();

    const addToBasket = () => {
        dispatch ({
            type: 'ADD_TO_BASKET',
            item: {
                id: id,
                title: title,
                image: image,
                price: price,
            }
        })
    };

    return (
        <div className="product">
            <p>{title}</p>
            <small>$</small>
            <strong>{price}</strong>
            <img src={image} />
            <button onClick={addToBasket}>Add to Basket</button>
        </div>                
    )
}

export default Product

